
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen, langtw, langjp,langar, langxby,langdy, langydl, langpty,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  "请输入您的国家":"Bitte geben Sie Ihr Land ein",
  "借贷审核中":"Kredit wird geprüft",
  "完成":"Fertiggestellt",
  "可用贷款池":"Verfügbarer Kreditpool",
  "直观易用的界面":"Intuitive und benutzerfreundliche Oberfläche",
    "访问 3,000 多个市场":"Zugriff auf über 3.000 Märkte",
    "实时更新和价格提醒":"Echtzeit-Updates und Preiswarnungen",
    "各种技术指标、分析工具和高级图表":"Verschiedene technische Indikatoren, Analysetools und erweiterte Diagramme",
    "先进的对冲策略和综合风险管理工具":"Fortgeschrittene Absicherungsstrategien und umfassende Risikomanagement-Tools",
  "操作不熟练,试试模拟交易": "Ungeübt? Demo-Trading testen",
  "访问我们的帮助中心,获取交易指南": "Hilfezentrum für Handelsleitfäden besuchen",
  "希望增进您的交易技巧？": "Handelsfähigkeiten verbessern?",
  "每月提取金额": "Monatlicher Auszahlungsbetrag",
  "交易者": "Händler",
  "亿": "Hundert Millionen",
  "万": "Zehntausend",
  "3000多种品类供您选择": "Über 3000 Produkte verfügbar",
  "24小时交易量": "24-Stunden-Handelsvolumen",
  "线上交易,请选择":"For online trading, please choose",
  "交易所":"Exchange",
  "3000多种品类,包括加密货币,贵金属,外汇, 原油等等":"More than 3,000 categories, including cryptocurrencies, precious metals, foreign exchange, crude oil, etc.",
  "立即交易":"Trade now",
  "希望增进您的交易技巧":"Hope to improve your trading skills",
  "访问我们的帮助中心,获取全面交易指南":"Visit our help center for a comprehensive trading guide",
  "去看看":"Go and have a look",
  "操作不熟练,试试我们的模 拟交易功能":"If you are not familiar with the operation, try our simulated trading function",
  "免费体验交易,让您尽快上手":"Free experience trading, so that you can get started as soon as possible",
  "马上体验":"Experience now",
  "充币":"Deposit",
  "提币":"Withdraw",
  "客服":"Customer service",
  "更多":"More",
  "热门品种":"Popular products",
  "卖出":"Sell",
  "买入":"Buy",
  "了解我们的平台":"Learn about our platform",
  "直观易用":"Intuitive and easy-to-use",
  "的界面":"Interface",
  "定期提供":"Regularly",
  "3,000多个市场":"3,000+ markets",
  "的实时更新和 价格警报":"Real-time updates and price alerts",
  "各种技术指标":"Various technical indicators",
  "分析工具和高级图表":"Analysis tools and advanced charts",
  "套期保值模式和":"Hedging mode and",
  "风险管理工具":"Risk management tools",
  "我们创建了技术领先且人性化的交易平台 ,为您提供贴心完善的交易体验":"We have created a technologically advanced and user-friendly trading platform to provide you with a thoughtful and complete trading experience",
  "实时新闻咨询":"Real-time news consultation",
  "紧跟我们的新闻、产品和活动信息":"Keep up with our news, products and event information",
  "阅读更多新闻":"Read more news",
  "合作伙伴等最新新闻动态":"Partners and other latest news",
  "AI智能赚币":"AI smart money earning",
  "出金":"Withdrawal",
  "随存随取":"Deposit and withdraw at any time",
  "一键即刻取出,从不等待":"Withdraw immediately with one click, never wait",
  "稳定":"Stability",
  "最稳健的理财":"The most stable financial management",
  "稳定收益,您的理财助手":"Stable income, your financial assistant",
  "执行速度":"Execution speed",
  "极速执行":"Extremely fast execution",
  "所有订单将以毫秒级别速度执行":"All orders will be executed at milliseconds",
  "每天发放":"Distribution every day",
  "当天产生收益":"Profits are generated on the same day",
  "当天购买当天产生收益,24小时及时发放收益":"Profits are generated on the same day of purchase, and profits are distributed promptly 24 hours a day",
  "现在就开始":"Start now",
  "交易全球金融市场":"Trade in the global financial market",
  "支持桌面端与移动端多种方式,您可随时 随地开展交易":"Supports multiple methods of desktop and mobile terminals, you can trade anytime, anywhere",
  "谷歌下载":"Google download",
  "下载":"Download",
  "公司":"Company",
  "关于我们":"About us",
  "许可证监督":"License supervision",
  "帮助中心":"Help center",
  "政策":"Policy",
  "条款与条件":"Terms and conditions",
  "隐私政策":"Privacy policy",
  "声明":"Statement",
  "法律信息":"Legal information",
  "免责声明":"Disclaimer",
  "风险警告":"Risk warning",
  "关于广告":"About advertising",
  currency: {
    bb: 'Umtauschen',
    bba: 'Währungskonto',
    hy: 'Verträge',
    jg: 'Optionshandel',
    jg1: 'Zukünfte',
    hya: 'Vertragskonto'
  },
  home:{
    user:'Gemeinsame Auswahl der Benutzer',
    start:'Mit dem handel beginnen',
    trading:'Handelsprodukte',
    fee:'Mindestbearbeitungsgebühr',
    co:'Co',
    varieties:'Handelssorten',
    leading:'Führend bei der Innovation und Erforschung von web3',
    market:'Markttrends von Handelsprodukten',
    explore:'Entdecken Sie endlose Möglichkeiten',
    newcurrency:'Die neue Währungsabonnementfunktion ist online!',
    alimited:'Neue Münzen sind online, Sie können hier neue Münzen kaufen, von denen Sie glauben, dass sie Potenzial haben',
    get_start:'Fangen Sie an',
    ai_coin:'Der AI-Coin-Verdienstplan ist in Arbeit',
    ai_text:'Beginnen Sie mit dem Verdienen von Münzen mit KI, stabilem Einkommen und hoher Rendite, sodass Sie im Liegen Münzen verdienen können',
    loan:'Die Ausleihfunktion ist online',
    loan_text:'Wenn Sie kein Geld haben, können Sie einen Kredit beantragen, der noch am selben Tag ausgezahlt wird',
    mobile_pc:'Wird von Krankenschwestern auf mobilen PCs verwendet',
    pc_anytime:'Beginnen Sie jederzeit und überall mit dem Handel:',
    pc_text:'Wir bieten leistungsstarke Diagrammanalysetools: mehr als fünfzig technische Indikatoren und Festplattenanalysetools. Sichere, zuverlässige, benutzerfreundliche Leverage- und High-Leverage-Funktionen sind zur Standardplattform für Online-Investitionen geworden.',
    mobile_down:'Klicken Sie hier zum Herunterladen',
    mobile_android:'Androidmarkt',
    mobile_ios:'Apple Laden',
    open_text:'Sie können ein echtes Handelskonto beantragen oder ein Demokonto kostenlos für ein Drittel der Kosten ausprobieren.',
    open_account:'ein Konto',
    tocomplete:'fertigstellen',
    walletlogin:'Wallet-Login'
  },
  index: {
    h24: '24-Stunden-Volumen',
    header_title: ['Wählen Sie den Handel mit digitalen Vermögenswerten ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title:'Schließen Sie die Blockchain-Transaktion für digitale Vermögenswerte aus einer Hand ab',
    header_msg: 'Sicher-stabil-vertrauenswürdig',
    register_title: 'Registrieren ' + window.GLOBAL.LANG_TITLE.zh + ' Globales Konto beginnt Handelsreise',
    register_pl: 'Bitte geben Sie Ihre E-Mail oder Handy ein',
    register: 'Registrieren',
    featureTitleWhy:'Warum uns wählen',
    featureTitle:'Sicher · Stabil · Zuverlässig',
    featureMsg: '',
    featureList: [
      {icon: icon1, title:'Secure Wallet Technology', msg: ['Die Cold- und Hot-Wallet-Technologie wurde vom weltbesten Sicherheitsteam entwickelt und es gab noch nie einen Vorfall mit Münzverlusten. ',''] },
       {icon: icon2, title:'reiches Krypto-Asset-Geschäft', msg: ['Unterstützung von Spot- und Mehrfachderivat-Transaktionen usw. ist Ihr persönlicher Verwalter in der Welt der Krypto-Assets. ',''] },
       {icon: icon3, title:'Kunden auf der ganzen Welt verteilt', msg: ['Für Benutzer in mehr als 130 Ländern oder Regionen auf der ganzen Welt bieten wir eine vollständige Palette von Diensten für verschlüsselte Assets. ','']}
    ],
    bannerList: [
      {icon: banner01,title: "Verpflichtet, branchenführende Sicherheit und Stabilität zu bieten", msg: ["intelligente Verträge zum Schutz der Sicherheit von Anlegern", "reale Handelsleistung", "24-Stunden-Servicegarantie"] },
      {icon: banner02,title: "Ich möchte durch einfache Operationen sofort kaufen und verkaufen", msg: ["einfacher Handelsbildschirm", "wird sofort in Ihrem Kontostand angezeigt", "die meisten Kryptowährungen können gehandelt werden" ] },
      {icon: banner03,title: "Ich möchte durch Settlement-Kontrakthandel aktiv Gewinne erwirtschaften", msg: ["Gleichzeitig Konto eröffnen", "Strategische Anlage für eine Vielzahl von Trading-Futures", "Sie können 24 handeln Stunden am Tag, 365 Tage im Jahr, auch am Wochenende"]}
    ],
    featureList2: [
      {icon: icon1_01, title: "Transparency and Openness", msg: ["Verwendung der Eigenschaften von Blockchain und Smart Contracts, Realisierung der Transaktionsleistung in der Kette und Verwendung von Smart Contracts, um die Sicherheit der Vermögenswerte der Anleger zu gewährleisten",""] },
      {icon: icon1_02, title: "Smart Investment", msg: ["Mit den diversifizierten Strategien der besten quantitativen Handelsexperten haben Sie die freie Wahl",""] },
      {icon: icon1_03, title: "Risk Grading", msg: ["Gestalten Sie diversifizierte Anlageprodukte basierend auf den unterschiedlichen Risiken und Vermögensverwaltungspräferenzen jedes Anlegers und beseitigen Sie effektiv Anlageschwellen", ""] },
      {icon: icon1_04, title: "Diversified Products", msg: ["Verschiedene Arten von Benutzerinvestitionsbedürfnissen und flexible Plattformmechanismen bereitstellen und weiterhin innovative Finanzdienstleistungen produzieren, die besser sind als der Markt", ""]}
    ],
    featureTitle2:'Multi-Plattform-Terminal-Transaktion jederzeit und überall',
    featureMsg2:'Abdecken von iOS und Android auf mehreren Plattformen, Unterstützung aller Geschäftsfunktionen',
    tab: ['Mainstream-Währung', 'Liste der Erhöhungen rund um die Uhr'],
    thead: ['Handelspaar','Neuster Preis','Höchster Preis des Tages','Niedrigster Preis des Tages','Aufsteigende Liste', '24H Volumen','Operation'],
    more:'Mehr anzeigen >',
    btn:'Transaktion',
    DealsTitel:'Handelsservice aus einer Hand',
    dealsTab:[
      { title: 'Umtauschen', content: 'Der Devisenhandel dient dem Austausch zwischen digitalen Vermögenswerten, wobei USDT als Bewertungseinheit für den Kauf anderer Währungen verwendet wird.'+window.GLOBAL.LANG_TITLE.zh+'Währungstransaktionen unterstützen Echtzeittransaktionen von digitalen Assets wie Bitcoin, Ethereum und Litecoin.', src:'/static/image/deals-1.jpg', path: '' },
      { title: 'Vertrag', content: 'Ein Finanzderivat einer digitalen Währung unterstützt nicht nur die Wahl zwischen dem Kauf von Long- oder Short-Selling-Kontrakten, um Einnahmen zu erzielen, sondern ist auch einfach zu bedienen und läuft nie ab.'+window.GLOBAL.LANG_TITLE.zh+'Der Vertrag verfügt über ein fortschrittliches Risikomanagementsystem mit bis zu 100-facher Hebelwirkung.', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['Optional', 'Vertrag', 'Münzen'],
    thead: ['Währung','Neuester Preis', '24H-Änderung', '24H-Niedrigster', '24H-Höchster', '24H-Volumen','Operation'],
    nodata: 'Keine Daten'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [
      {
        dt: "Über uns",
        dd: [{title: "Firmenprofil", ID: 1 }, { title: "Hilfezentrum", type:'help'}]
      },
      {
        dt: "Benutzer-Support",
        dd: [
          {title: "Benutzervereinbarung", ID: 3 },
          {title: "Datenschutzerklärung", ID: 5}
        ]
      },
      {
        dt: "kontaktiere uns",
        icon: true
      }
    ],
    terms: "Geschäftsbedingungen",
    serve: "Aufschlag",
    product: "Produkt",
  },
  nav: {
    btn: ["Einloggen", "Registrieren", "Anlagenmanagement","Lade App herunter"],
    nav: [
      // { title: "Startseite", path: "/index",name: 'index' },
      // { title: "Umtauschen", path: "/deal",name: 'deal' },
      { title: "Markt", path: "/market",name: 'market' },
      { title: "Handeln", path: "/preciousMetal", name: 'preciousMetal'},
      // { title: "Umtauschen", path: "/deal", name: 'deal'},
      // { title: "Vertrag", path: "/deal_c", name: 'deal_c' },
      // { title: "Kryptowährung", path: "/deal_jg", name: 'deal_jg' },
      { title: "Finanziell", path: "/profit_index",name: 'profit_index' },
      // { title: "Aktivität", path: "/sign",name: 'sign' }
    ],
    nav2: [{ title: "Meine Assets", path: "/asset" }],
    menus: [
      { icon: langzh, title: "Benutzercenter", path: "/setting" },
      { icon: langen, title: "austragen" }
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      { icon: langxby, lang: "España", key: 'es' },
      { icon: langfy, lang: "français", key: 'fr' },
      { icon: langdy, lang: "Deutsche", key: 'de' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      // { icon: langar, lang: "عربي", key: 'ar' },
      { icon: langhy, lang: "한국어", key: 'kr' },
      { icon: langty, lang: "ไทย", key: 'th' },
      { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
 { icon: langydl, lang: "Italia", key: 'it' },
      { icon: langpty, lang: "Portugal", key: 'pt' },
      // { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'tw' },
    ]
  },
  download:{
    "xz": "Download"
  },
  // 登录
  // login: {
  //   login: 'Bitte einloggen',
  //   msg: 'Bitte geben Sie Ihr registriertes Konto ein',
  //   list: ['Mobil/E-Mail','Passwort','Passwort vergessen?','Anmelden','Kein Konto, jetzt registrieren'],
  //   message: 'Konto oder Passwort dürfen nicht leer sein'
  // },
  register: {
    dl: ['Über Mobiltelefon registrieren', 'Über E-Mail registrieren'],
    title: 'Registrieren Sie einen Account',
    country:'Nationalität',
    country_info:'Nationalitätsinformationen können nach der Registrierung nicht geändert werden, bitte wählen Sie wahrheitsgemäß',
    account: 'Kontonummer',
    code_text: 'Verfikationscode',
    code_btn: 'CAPTCHA erhalten',
    code_unit: 's',
    code_no_data: 'Bestätigungscode muss ausgefüllt werden',
    password_text: 'Passwort eingeben',
    password_again_text: 'Passwort erneut eingeben',
    pid_text: 'Einladungscode',
    pid_pl: 'Optional',
    invitation_code_no_data:'Einladungscode ist erforderlich',
    xy:'Benutzervereinbarung',
    xy_no_checked:'Bitte wählen Sie das Protokoll aus',
    agree:'Ich habe gelesen und zugestimmt',
    register_btn:'Registrieren',
    bz: ['Nationalitätsinformationen können nach der Registrierung nicht geändert werden, bitte achten Sie darauf, dass Sie wahrheitsgemäß wählen. ','Die Bestätigungs-E-Mail wird möglicherweise fälschlicherweise als Spam eingestuft, bitte überprüfen Sie sie sorgfältig. ','Bitte bewahren Sie Ihr Konto richtig auf' + window.GLOBAL.LANG_TITLE.zh +'Konto und Login-Passwort. ','Verwenden Sie nicht dasselbe Login-Passwort wie bei anderen Websites. '],
    account_no_data: 'Konto darf nicht leer sein',
    code_no_equality: 'Bestätigungscodes sind nicht gleich',
    password_no_data: 'Passwort darf nicht leer sein',
    password_no_equality: 'Die beiden Passwörter sind nicht gleich'
  },
  // 设置密码
  bindmpwd: {
    title: 'Passwort festlegen',
    account: 'Kontonummer',
    code_text: 'Verfikationscode',
    code_btn: 'CAPTCHA erhalten',
    code_unit: 's',
    password_text: 'Passwort eingeben',
    password_again_text: 'Passwort erneut eingeben',
    code_no_data: 'Bestätigungscode muss ausgefüllt werden',
    code_no_equality: 'Bestätigungscodes sind nicht gleich',
    password_no_data: 'Passwort darf nicht leer sein',
    password_no_equality: 'Die beiden Passwörter sind nicht gleich',
    bindmpwd_btn: 'Bestätigen',
    phone_no_data: 'Telefonnummer darf nicht leer sein',
    password_login_text: 'Bitte geben Sie Ihr Login-Passwort ein',
    password_trade_text: 'Passwortlänge 6 Ziffern',
    password_again_tarde_text: 'Passwortlänge 6 Ziffern',
  },
  // 忘记密码
  forgetpwd: {
    title: ['Passwort ändern', 'Passwort vergessen'],
    account: 'Kontonummer',
    code_text: 'Verfikationscode',
    code_btn: 'CAPTCHA erhalten',
    code_unit: 's',
    password_text: 'Passwort eingeben',
    password_again_text: 'Passwort erneut eingeben',

    phone_no_data: 'Telefonnummer darf nicht leer sein',

    account_no_data: 'Konto darf nicht leer sein',
    code_no_data: 'Bestätigungscode muss ausgefüllt werden',
    code_no_equality: 'Bestätigungscodes sind nicht gleich',
    password_no_data: 'Passwort darf nicht leer sein',
    password_no_equality: 'Die beiden Passwörter sind nicht gleich',
    forgetpwd_btn: 'Bestätigen'
  },
  // 绑定手机号码
  bindphone: {
    title: 'Handynummer binden',
    phone_text: 'Telefonnummer',
  },
  person: {
    more: 'Mehr laden',
    no_more: 'Keine Daten mehr',
    index_center:"Benutzercenter",
    index_menus: [
      { icon: zhsz, title: "Kontoverwaltung", path: '/setting' },
      { icon: sfrz, title: "KYC-Authentifizierung", path: '/sfyz' },
      { icon: sfrz, title: "Junior-Zertifizierung", path: '/smauth' },
      { icon: sfrz, title: "Verifiziert", path: '/seniorauth' },
      { icon: jtrz, title: "Adressauthentifizierung", path: '/dzrz' },
      { icon: jtrz, title: "Crypto kaufen", path: '/kjmbSelect' },
      { icon: jtrz, title: "Kreditwürdigkeit", path: '/credit' },
      { icon: jtrz, title: "Aufzeichnungen", path: '/deallog' },
      { icon: jtrz, title: "Aufzeichung der Aufladungen", path: '/cbjl' },
      { icon: jtrz, title: "Aufzeichnung der Abhebungen", path: '/tbjl' },
    ],
    cbtb: 'Einbezahlen & Abheben',
    jymx: 'Detail zur Transaktion',
    xyf: {
      'title': 'Kreditwürdigkeit',
      'pgsj': 'Auswertungszeit'
    },
    smrz:{
       title:'Verifiziert' ,
       sure_title:'Sie haben die Echtnamen-Authentifizierung bestanden',
       zj_type:'Zertifikatstyp',
       zj_info:['1, die Zertifizierungsinformationen können nach der Verifizierung nicht mehr geändert werden, bitte wahrheitsgemäß ausfüllen','2, die verifizierten Echtnameninformationen können nicht erneut zertifiziert werden'],
       zj_name:'Name',
       zj_num:'Dokumentnummer',
       zj_btn:'OK',
       zj_rebtn:'Erneut verifizieren',
       zj_sebtn:'Erweiterte Verifizierung',
       zj_type_array:[{name:'Personalausweis',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "Personalausweis"
        },
        {
            id: 2,
            name: "Pass"
        },
        {
            id: 3,
            name: "Führerschein"
        },
        {
            id: 4,
            name: "Aufenthaltsgenehmigung"
        },
        {
            id: 5,
            name: "Andere Arten von Ausweise"
        }
       ],
       zj_data:{city:'Nationalität darf nicht leer sein',type:'Anmeldeinformationstyp darf nicht leer sein',name:'Name darf nicht leer sein',zj_num:'Ausweisnummer darf nicht leer sein'},
       zsxm: 'Echter Name',
       qsrzsxm: 'Bitte Ihren echten Namen eingeb',
       zjlx: 'Art des gültigen Ausweises',
       qxzzjlx: 'Bitte Art von Anschrift wählen',
       sfz: 'Personalausweis',
       zjhm: 'Ausweisnummer',
       qsrzjhm: 'Bitte Ausweisnumemr eingeben',
       sczjz: 'Fotos des Ausweises hochladen',
       zjzm: 'Vorderseite des Ausweises hochladen',
       zjfm: 'Rückseite des Ausweises hochladen',
       qsczjzm: 'Bitte laden Sie das Vorderfoto Ihres Ausweises hoch',
       qsczjfm: 'Bitte laden Sie ein Foto von der Rückseite Ihres Ausweises hoch',
       scqmz: 'Dokumente zum Ausweis und persönliche Unterschrift hochladen',
       qscscqmz: 'Bitte laden Sie Ihren Ausweis und Ihr persönliches Unterschriftsfoto hoch',
       zj: [
         {
           id: 1,
           title: 'Personalausweis'
         },
         {
           id: 2,
           title: 'Pass'
         },
         {
           id: 3,
           title: 'Andere Arten von Ausweise'
         },
       ],
       tj: 'Einreichen',
       shz: 'Wird geprüft',
       shtg: 'Genehmigt'
    },
    gjrz:{
      title:'Senior-Zertifizierung',
      zj_info:['1. Es werden Bilder unterstützt, die kleiner als 8 MB sind und im JPG-, JPEG- oder PNG-Format vorliegen.','2. Die Fotos des Dokumente zum Ausweis müssen lesbar sein und dürfen nicht verändert oder gesperrt werden. Das persönliche Foto  und die Dokumentennummer und der Name des Dokumenteninhabers müssen deutlich sichtbar sein.','3. Die Fotos müssen ohne Kopfbedeckung aufgenommen werden und sollten keine Schminke enthalten. Die Gesichtszüge auf dem Foto sollten klar und deutlich erkennbar sein und die Arme sollten vollständig sichtbar sein.'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'Sicherheitseinstellungen',
      bind:[{bind_title:'Passwort zurückstellen',bind_name:'Briefkasten'},{bind_title:'Passwort zum Abheben einstellen',bind_name:'Briefkasten'}]
    },
    wdtg:{
      own_code:'专属邀请码',
      own_code_url:'专属邀请连接',
      own_push_title:'我的推广',
      own_push_content:['邀请总收入（估值）','邀请人数','人'],
      own_push_content_profit:['一级邀请收益','二级邀请收益','三级邀请收益','四级邀请收益'],
      own_push_content_num:['一级邀请人数','二级邀请人数','三级邀请人数','四级邀请人数'],
      own_push_profit_title: ['ID', '收益', '备注信息','添加时间'],
      own_push_num_title: ['ID', '名称', '电话','添加时间'],
    },
    jyzt_td: ['Zeit','Details','Betrag'],
    cbjl_td: ['Zeit','Währung','Menge','Status'],
    sfrz_txt: ['Identitätsauthentifizierung','Sie haben die Bewertung abgegeben, bitte warten Sie auf das Ergebnis','Sie haben die erweiterte Authentifizierung bestanden','Vorderseite des Personalausweises','Rückseite des Personalausweises','Authentifizierung','Authentifizierung fehlgeschlagen, Bitte authentifizieren Sie sich erneut'],

    zhsz_txt: ['Ihre Kontosicherheitsstufe: #','Ihre Kontosicherheitsstufe: #, mehr Informationen verbessern und die Kontosicherheit gewährleisten'],
    zhsz_m:'stark',
    zhsz_n:'schwach',
    zhsz_p:'unsicher',
    zhsz_detailList: [
      { icon: '/static/image/User_Center-password.png', title: 'Login-Passwort', value: 'Es besteht die Gefahr, dass Internetkonten gestohlen werden. Es wird empfohlen, Ihr Passwort regelmäßig zu ändern, um die Sicherheit Ihres Kontos zu gewährleisten.',value2:'', btn: 'Ändern',bind_email:'Bitte binden Sie zuerst Ihre E-Mail oder Ihr Handy', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: 'Passwort für Transaktionen', value: 'Passwort festlegen', btn: 'Gehe zum Set', path: '/bindmpwd' }
    ],
    sksz_txt: ['Empfangseinstellungen','Speichern'],
    sksz_list: [
      { label: "用户名:", pl: "请输入用户名", key: "name" },
      { label: "开户行名称:", pl: "请输入开户行名称", key: "bank_name" },
      { label: "银行卡号:", pl: "请输入银行卡号", key: "bank_number" },
      { label: "支付宝账号:", pl: "请输入支付宝账号", key: "alipay_account" },
      { label: "微信昵称：", pl: "请输入微信昵称", key: "weixin_nickname" },
      { label: "微信账号：", pl: "请输入微信账号", key: "weixin_account" }
    ]
  },
  pasination: {
    first: 'Startseite',
    prev:'Vorherige Seite',
    next:'Nächste Seite',
    last:'Letzte Seite',
    no_data: 'Keine Daten',
  },
  asset: {
    title: 'Meine Assets',
    zjhz: 'Überweisung',
    cb: 'Währung aufladen',
    gz: 'USDT-Bewertung',
    atnv: [],
    zh_title: 'Gesamtvermögen umgerechnet：',
    index_title: 'Vermögenswerte',
    address_title: 'Währung',
    address_txt: ['bitte auswählen', 'Adresse der Abhebung', 'Bitte Inhalt eingeben','Bemerkungen','Adressliste'],
    address_btn: ['Hinzufügen','Speichern','Löschen','Bearbeiten'],
    address_td: ['Währung', 'Adresse der Abhebung', 'Bemerkung', 'Bedienung'],
    currency_td: ['Währung', 'Verfügbar', 'Einfrieren', 'Konversion'],

    table_title: 'Bilanzsumme：',
    table_address_title: 'Abhebungsadressenverwaltung',
    table_td: ['Währung', 'Verfügbar', 'Einfrieren', 'Konversion', 'Bedienung'],
    table_btn: ['Währung aufladen', 'Währung abheben', 'Aufzeichnung', 'Transfer'],

    money_text: ['Adresse der Abhebung', 'bitte auswählen', 'Betrag', 'Verfügbar：', 'Gebühren',
      'Eingehender Betrag', 'Passwort für Transaktionen','Tag (Memo)','Minimum '],
    money_btn: 'Währung abheben',
    xzbz: 'Währung wählen',
    money_msg: ['Hinweis', '1. Auszahlungszeit ist 12:00-24:00 Uhr Hongkonger Zeit, und Sie können zwei Auszahlungsanträge pro Tag einreichen (die Mindestauszahlung beträgt 100u, die maximale Auszahlung beträgt 200.000u);', '2. Derzeit unterstützt die Auszahlung nur die USDT-Währung und der Wallet-Link-Typ wählt ERC20;','3. Nach dem Einreichen des Auszahlungsantrags befinden sich die Gelder in einem eingefrorenen Zustand, da die Auszahlung im Gange ist, und die Gelder befinden sich vorübergehend in der Verwahrung des Systems und können von Ihnen nicht frei kontrolliert werden. Dies bedeutet nicht, dass Sie den Vermögenswert verloren haben oder der Vermögenswert abnormal ist. Bitte warten Sie geduldig auf die Genehmigung im Prozess;','4. Nach dem Absenden des Widerrufsantrags richtet sich die Ankunftszeit nach der Sperrbestätigungszeit Ist der Widerruf nach der Widerrufsfrist nicht zu erwarten, wenden Sie sich bitte für Rückfragen an den Kundenservice;','5. Um Arbitrage zu verhindern, werden 90% des Gesamtverbrauchsbetrags benötigt, um eine Auszahlung einzuleiten'],

    recharge_title: 'Aufladeadresse',
    recharge_btn: ['Kopieren', 'QR-Code', 'Währung aufladen'],
    recharge_text: ['Betrag', 'Hinweis', 'Bitte hinterlegen Sie keine Nicht-USDT-Vermögenswerte an die oben genannte Adresse, andernfalls werden die Vermögenswerte nicht abgerufen.', 'USDT-Einzahlungen unterstützen nur die einfache Sendemethode. Einzahlungen mit anderen Methoden (alle senden) können vorübergehend nicht gebucht werden. Bitte haben Sie Verständnis.', 'Zertifikat', 'beschreiben(Optional)','Name der Kette'],

    record_title: 'Finanzunterlagen',
    record_td: ['Betrag', 'Aufzeichnung', 'Zeit'],

    transfer_title: 'Transfer',
    transfer_btn: ['Alle', 'Transfer'],
    transfer_text: ['Von', 'zu', 'Bitte geben Sie den Überweisungsbetrag ein', 'Verfügbar：'],
    "bq": "Tag (Memo)",
    "qsrbq": "Bitte das Tag eingeben",
    "yhktx": "Über Bankkarte abheben",
    "yhmc": "Bankname",
    "qsryhmc": "Bitte Bankname eingeben",
    "yhzh": "Bankkonto",
    "qsryhzh": "Bitte Bankkontonummer eingeben",
    "gjhkdm": "SWIFT-Code",
    "qsrgjhkdm": "Bitte SWIFT-Code eingeben",
    "yhdz": "Adresse der Bank",
    "qsryhdz": "Bitte Adresse der Bank eingeben",
    "skrxm": "Name des Zahlungsempfängers",
    "qsrskrxm": "Bitte Name des Zahlungsempfängers eingeben",
    "skrdh": "Telefon des Zahlungsempfängers",
    "qsrskrdh": "Bitte Telefon des Zahlungsempfängers eingeben",
    "skrdz": "Adresse des Zahlungsempfängers",
    "qsrskrdz": "Bitte Adresse des Zahlungsempfängers eingeben"
  },
  text: {
    btn:'zurück',
    login:'Bitte zuerst einloggen'
  },
  deal: {
    chooseType: 'Provisionsart',
    choose: 'bitte auswählen',
    balance: 'Saldo：',
    account: ['Konto', 'Verfügbar', '/Einfrieren', 'Transfer'],
    dir: ['Kaufen', 'Verkaufen'],
    dir2: ['Verfügbar', 'Vermarktbar'],
    cs: 'Optional',
    sxf: 'Gebührrate',
    jye: 'Umsatz',
    sc_list: ['Markt','Münzenpaar','erhöhter Preis'],
    sc_h: ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
    td_lt: ['Währung', 'Aktuellster Pre', 'Erhöhen, ansteigen'],
    k_line_txt: ['≈', '', 'Erhöhen','Höchster Preis','Niedrigster Preis', '24-Stunden-Volumen'],
    tabListLTitle: ["Aktuelle Aufträge", "Kommission-Historie"],
    tabListLEntrust: ["Kaufen", "Verkaufen"],
    tabListRTitle: ["Grenzpreishandel", "Marktpreishandel"],
    table_btn: ['Abheben'],
    index_td_l: ['Zeit', 'Handelspartner', 'Betrag', 'Preis', 'Bedienung'],
    index_td_r: ['Aktuellster Pre', 'Richtung', 'Preis', 'Betrag'],
    index_td_r2: ['Letzte Transaktion', 'Zeit', 'Preis', 'Handelsvolumen'],
    table_txt: ['Abgeschlossen', 'Abgehoben'],

    db_1_txt: ['Verfügbar', 'Kaufpreis', 'Verkaufspreis', 'Volumen der Käufe', 'Verkaufsvolumen', 'Umsatz', 'Kaufen zum besten Marktpreis','Verkaufen zum besten Marktpreis','Hand kaufen','Hand verkaufen'],
    db_2_txt: ['Preis', 'Hebelwirkung', 'bitte auswählen', 'Lot', '1lot =', 'Lot', 'Vertragsmarktwert', 'Bonds', 'Kaufen zum besten Preis auf dem Markt','Verkaufen zum besten Preis auf dem Markt'],
    pathList: ['Vertragsdatensatz','Transaktionsdatensatz'],
    db_btn: ['Kaufen (lang)','Verkaufen (kurz)'],
    tabListLTitle2: ['Aktuelle Aufträge'],

    lt_btn: ['Ein-Klick-Liquidation', 'Stop-Gewinn- und Stop-Loss-Preis festlegen', 'Liquidation', 'Jetzt Absenden', 'Rückkehr'],
    lt_txt: ['Risikorate：', 'Gesamtprofit：'],
    lt_td: ['Typ','Hebelwirkung', 'Preis der Position', 'Aktueller Preis', 'Bonds', 'Take-Profit-Preis', 'Stop-Loss-Preis', 'Eröffnungszeit', '手数', 'Profit und Verlust', 'Bedienung'],
    lt_dl: ['Stop-Gewinn- und Stop-Loss-Preis festlegen', 'Take-Profit-Preis', 'Stop-Loss-Preis'],

    lt_0_btn: ['Abheben'],
    lt_0_td: ['Kontaktdetails', 'Währung', 'Betrag', 'Aktueller Preis', 'Gebühren', 'Bedienung'],

    lt_1_btn: ['Liquidation'],
    lt_1_txt: ['Wird geschlossen'],
    lt_1_td: ['Typ', 'Preis der Position', 'Aktueller Preis', 'Bonds', 'Take-Profit-Preis', 'Stop-Loss-Preis', 'Eröffnungszeit', 'Gebühren', 'Profit und Verlust', 'Bedienung'],
    node_data: 'Keine Daten',

    lt_3_txt: ['Abgeschloss', 'Liquidation'],
    lt_3_td: ['Typ', 'Lot', 'Preis der Position', 'Schlusskurs', 'Take-Profit-Preis', 'Stop-Loss-Preis', 'Bonds', 'Verfügbare Bonds', 'Eröffnungszeit', 'Schließzeit', 'Gebühren',
      'Profit und Verlust', 'Bedienung'],

    lt_4_txt: ['Abgehoben'],
    cm: ['Zeit der Ausgabe', 'Menge der Ausgabe', '流通总量', '总凑价格', 'Offizielle Webseite','Weißes Papier','Einführung'],
    qsrsl: 'Bitte Betrag eingeben',
    qsrss: 'Bitte geben Sie das Los ein',
  },
  notice:{
      notice_title:'Ankündigungszentrum',
  },
  bzhl:{
    title: 'KI-Investition',
    title1: 'KI-Quantifizierung',
    ttzbt: '天天赚不停',
    wdtg: 'Mein Hosting',
    zztgdzj: 'Hinterlegte Fonds',
    yjjrsy: 'Geschätzt täglich',
    ljsy: 'Einträge Insgesamt',
    tgzdd: 'Hinterlegte Bestellungen',
    tgdd: 'Hinterlegungs-Bestellung',
    t1: 'Risikoarmes und stabiles Finanzmanagement, bei Bedarf jederzeit einlösbar',
    t2: 'Ihr kostenloser Geldverwaltungsassistent',
    cljxcp: 'Produkt-Zyklus',
    dbxe: 'Single-Limit',
    rsyl: 'Tägliche Gewinnrate(%)',
    rsyl2: 'Tägliche Gewinnrate：',
    zq: 'Zyklus',
    qmr: 'Geh einkaufen',
    ckgd: 'Mehr sehen',
    cpgk: 'Produktübersicht',
    pxsj: 'Auszahlungszeitpunkt der Dividente',
    tgzj: 'Kapital der Hinterlegung',
    tqsh: 'Vorzeitige Rückzahlung',
    cpld: 'Produkt-Highlights',
    cpgz: 'Produktregeln',
    cont: 'Der Ziegelumzug erfolgt durch das Hosten von USDT auf der Plattform, und das professionelle Team der Plattform führt das Recht aus, Ziegel zu bewegen. Die Teilnehmer können den Anteil der Plattform an den Einnahmen aus dem Ziegelumzug während der Fondsverwahrfrist erhalten, auf die jederzeit zugegriffen werden kann. was sicher und bequem ist.',
    zj: '100% Förderung',
    aqbz: 'Sicherheit',
    jjrsy: 'Einnahmen an Feirtagen',
    bjd: 'Ununterbrochen',
    cgcrh: 'Nach erfolgreicher Anzahlung',
    dtqx: 'Zinsenwert an diesem Tag',
    ljzr: 'Jetzt überweisen',
    xqglgj: 'Kostenlose Geldmanagement-Tools',
    ddh: 'Bestellungsnummer',
    tgje: 'Treuhandbetrag',
    tgsj: 'Zyklustage',
    yhl: 'Profitiert',
    xdsj: 'Bestellzeitpunkt',
    zt: 'Status',
    fh: 'Rückkehr',
    qrnhsy: '七日年化收益',
    ygy: '1个月',
    bn: '半年',
    yn: '1年',
    yuan: '元',
    tzfx:'Anlagerisiko',
    shsc:'Einlösungszeit',
    di:'niedrig',
    yggzr:'Ein Arbeitstag',
    msgsxf:'Kostenlose Abonnementgebühr',
    mr: 'Täglich',
    dqfh: 'Rückerstattung wenn die Frist erreicht wird',
    ljgm: 'Jetzt kaufen',
    tgz: 'Wird hinterlegt',
    sh: 'Zurücknehmen',
    ywc: 'Abgeschlossen',
    ysh: 'Zurückgenommen',
    all: 'Alle',
    "xzbzts": "Einfach und sicher. Dividenden können in mehreren Währungen ausgewählt werden",
    "qtbz": "Andere Münzen"
  },
  pay:{
    qsrjymm:'Bitte 6-stelliges Transaktionspasswort eingeben',
    tbmmts:'Bitte gehen Sie zum Benutzercenter, um das Transaktionspasswort festzulegen',
  },
  tips:{
    qxztbdz:'Bitte geben Sie die Auszahlungsadresse ein',
    qsrtbsl:'Bitte geben Sie die Anzahl der Coins ein'
  },
  statusText: ['Fehlgeschlagen','Warten auf Verarbeitung','Erfolgreich'],
  dzrz: {
    title: 'Adressauthentifizierung',
    sdddz: 'Adresse der Stromrechnung',
    zdtpsc: 'Rechnungsbild hochladen',
    qsrsdddz: 'Sie müssen die Adressinformationen ausfüllen und die Stromrechnung oder die Breitbandadressrechnung einreichen',
    qsczdtp: 'Bitte lade ein Bild der Rechnung hoch',
    status: ['Genehmigt','Genehmigt'],
    qd: 'OK',
  },
  jgcc: {
    wtgd: 'Ausstehende Bestellung',
    cj: 'Deal',
    jj: 'Info',
    zc: 'Aktuell',
    lszc: 'Historie',
    qblx: 'Alle Arten',
    xj: 'Aktueller Preis',
    sj: 'Zeit',
    fx: 'Richtung',
    jg: 'Preis',
    sl: 'Betrag',
    jgsj: 'Liefezeit',
    gmj: 'Kaufpreis',
    jsj: 'Abrechnungspreis',
    yk: 'Profit und Verlust',
    xq: 'Details',
    "mz": "Bullisch",
    "md": "Bearisch",
    dqye: 'Aktuelles Saldo',
    gb: 'Schließen',
    jxxd: 'Weitere Bestellungen machen',
    qrxd: 'Bestätigen',
    ddqr: 'Bestätigung der Bestellung',
    sxf: 'Gebühren',
    kyye: 'Balance',
    jypz: 'Pair',
    jyfx: 'Richtung',
    tzje: 'Preis des Investment',
    tzjeTips: 'Investitionsbetrag darf nicht 0 sein',
    dqsj: 'Verfallsdatum',
    jssj: 'Lieferzeit',
    gmsj: 'Kaufzeit',
    sy: 'Profit',
    zxje: 'Mindestbetrag ',
    shi: 'H',
    fen: 'M',
    miao: 's',
    zdje: 'Höchstbetrag ',
    qsrje: 'Bitte Betrag eingeben',
    zxtzje: 'Mindestanlagebetrag ',
    yebz: 'Mangelhaftes Gleichgewicht',
    xq: 'Details',
    ddz: 'Warten',
    jgjl: 'Lieferschein',
    bz: 'Währung',
    cz: 'Bedienung'
  },
  kjmb: {
    title: 'Crypto kaufen',
    fzcg: 'Erfolgreich kopieren',
    ljmb: 'Crypto kaufen',
    lxkf: 'Kundenservice kontaktieren'
  },
  news: {
    title: 'Meine Nachricht',
    "gg": "Anküdigungen",
    ckxq: 'siehe Einzelheiten'
  },
  statusTabs:['Ausstehende Bestellung', 'Wird gehandelt','Abgeschloss', 'Abgehoben'],
  "chongzhi":{
    "zy": "Wichtig",
    "cbxx": "Token-Einzahlungsinformationen",
    "qsrsl": "Bitte geben Sie den Einzahlungsbetrag ein",
    "tips2": "1. Wallet/Plattform-Kompatibilität: Das heißt, das Netzwerk wird unterstützt; wenn die Zielplattform Ihr Auszahlungsnetzwerk nicht unterstützt, können die Vermögenswerte nicht abgerufen werden.",
    "tips3": "2. Ihr Aufladenetzwerk und die Zielplattform sind identisch: Wenn Sie als Zieladresse das Ethereum-Netzwerk wählen, die Aufladung jedoch die TRC20-Smart-Chain wählt, können Sie Ihre digitalen Assets möglicherweise nicht abrufen.",
    "tips4": "3. Vergewissern Sie sich vor dem Aufladen, dass Ihre Adresse und Ihr Betrag korrekt sind.",
    "tips5": " Zur Erinnerung: Aufgrund der Anonymität und Privatsphäre des Blocknetzwerks verlieren Sie bei der Eingabe falscher Informationen die entsprechenden Vermögenswerte. Bitte überprüfen Sie Ihre Aufladeadresse und Menge sorgfältig",
    "tips2_1": "• Bitte belasten Sie die obige Adresse nicht mit Vermögenswerten in anderen Währungen, da die Vermögenswerte sonst nicht abgerufen werden können.",
    "tips2_2": "• Die digitale Währung kann nicht rechtzeitig geliefert werden. Die tatsächliche Ankunftszeit hängt von der Bestätigungsgeschwindigkeit der Blockchain ab.",
    "tips2_3": "• Ihre Aufladeadresse wird sich nicht häufig ändern, Sie können aufladen; wenn es eine Änderung gibt, werden wir unser Bestes versuchen, Sie per Website-Ankündigung oder E-Mail zu benachrichtigen.",
  },
  "tibi":{
    "tbxx":"Informationen zum Widerruf",
    "qsrbq": "Bitte geben Sie ein Label ein",
    "tbTips1": "• Um die Sicherheit des Geldes zu gewährleisten, werden wir die Auszahlung manuell überprüfen, wenn sich Ihre Kontosicherheitsrichtlinien oder Ihr Passwort ändern. Bitte warten Sie geduldig, bis sich die Mitarbeiter telefonisch oder per E-Mail mit Ihnen in Verbindung setzen.",
    "tbTips2": "• Bitte stellen Sie sicher, dass Ihr Computer und Browser sicher sind, um zu verhindern, dass Informationen manipuliert oder durchgesickert werden.",
    "tbTips3": "• Der von Ihnen erwähnte digitale Vermögenswert ist ein Ein-Münzen-Mehrketten-Vermögenswert. Unabhängig davon, von welcher Kette Sie sich entscheiden, zu erhöhen, bedeutet dies, dass der Gesamtbetrag der digitalen Vermögenswerte, die auf Ihrer Auszahlungsseite angezeigt werden, reduziert wird. um den entsprechenden angehobenen Betrag .",
  },
  "gjlb": "Liste der länder.",
  "qxzgjlb": "Bitte wählen Sie Land / Region",
  "mbwt":{
    "title": "Einstellungen für Sicherheitsprobleme",
    "mbwt": "Sicherheitsprobleme",
    "problem":[
      {
        "id": 1,
        "title": "Was war dein bester Freund, als du ein Kind warst?"
      },
      {
        "id": 2,
        "title": "Wer ist dein Idol?"
      },
      {
        "id": 3,
        "title": "Wo ist dein sehnsüchtigster Ort?"
      }
    ],
    "qtxda": "Bitte fülle die Antwort aus",
    "qsrxmm": "Bitte geben Sie ein neues Passwort ein",
    "qqrmm": "Bitte Passwort bestätigen",
    "sydqmmcz": "Aktuelles Passwort zurücksetzen verwenden",
    "zhmm": "Sicherheitsprobleme Passwort abrufen",
    "ysz": "Wurde festgelegt",
    "tg": "über etwas springen",
    "tj": "einreichen",
    "zyts": "Wichtig:",
    "zytsCont": "Geben Sie die geheime Antwort und den Verifizierungscode nicht weiter und denken Sie an das Sicherheitsproblem, das Ihnen beim Abrufen Ihres Passworts hilft"
  },
  "zc":{
    "zclb": "Asset-Liste",
    "zczh": "Asset-Konvertierung",
    "yczc": "Assets, die Sie nicht haben, ausblenden"
  },
  "indexNew":{
    "t1": "Weltweit führend",
    "t2": "Digital Asset Service Platform",
    "t3": "Vollständige Blockchain-Transaktion für digitale Vermögenswerte aus einer Hand",
    "t4": "Mobilnummer/E-Mail",
    "t5": "Jetzt registrieren",
    "t6": "Willkommen Kunden aus der ganzen Welt durch MFTG",
    "t7":"Entdecken und starten Sie ihre Verschlüsselungsreise"
  },
  "newReg":{
    "dl": ['Email','Mobiltelefon'],
    "cjzh": "Benutzerkonto erstellen",
    "sysjhzyx": "Mit Handynummer/E-Mail registrieren",
    "yhxy": "&lt;Benutzervereinbarung&gt;",
    "yhxy2": "Ich habe die &lt;Benutzervereinbarung&gt; gelesen und stimme ihnen zu",
    "yxgz": "Bitte geben Sie eine gültige Email-Adresse ein",
    "dhgz": "Die Handynummer ist falsch"
  },
  "indexNew2":{
    "t1": "Trade auf unsere Bestellung",
    "t2": "Bitbank verwenden",
    "t3": "Bitbank ist ein ausgeklügelter Austausch von Bitcoin und verschlüsselten Vermögenswerten. Es ist sehr einfach, bequem, sicher und leistungsstark. Es unterstützt Transaktionen auf mehreren Web- und Smartphone-Plattformen. Transaktionsdaten und Diagramme werden in Echtzeit aktualisiert. Umfassend Die Marktpreisanalyse bietet mehr als 60 technische Analysetools. Beginnen Sie mit dem Handel",
    "ksjy": "Starten Sie den Handel",
    "ly": "5 Gründe, sich für Bitbank zu entscheiden",
    "item1_t1": "Führendes Handelsvolumen",
    "item1_t2": "Nr. 1 * Handelsvolumen von Krypto-Assets",
    "item1_t3": "Hohe Liquidität, komfortables (angenehmes Handelserlebnis) Trading. Listen Sie 12 Arten von Krypto-Assets auf.",
    "item2_t1": "Hohe Fremdbewertung",
    "item2_t2": "Sichere Handelsumgebung",
    "item2_t3": "Verwenden Sie offline Cold Wallet. Verwenden Sie Multisig, um Hacker fernzuhalten. Schützen Sie Ihre Vermögenswerte mit Hightech",
    "item3_t1": "Einfache Bedienung und zuverlässige Anwendung",
    "item3_t2": "Einfache Bedienung und einfache Anwendung",
    "item3_t3": "Eine zuverlässige Anwendung mit umfangreichen Funktionen. Sie kann Handelsmöglichkeiten außerhalb der Transaktion aufrechterhalten.",
    "item4_t1": "Ganztägig geöffnet",
    "item4_t2": "Kann Gold einzahlen",
    "item4_t3": "24-Stunden-Einzahlungsunterstützung, auch an Feiertagen!",
    "item5_t1": "Smartphone und PC",
    "item5_t2": "Humanisiertes Design",
    "item5_t3": "Auch wenn Sie ein Smartphone verwenden, können Sie bedenkenlos einfache und qualifizierte Transaktionen durchführen",
    "aqkk": "Sicher und zuverlässig",
    "aqkk2": "Bitbank Bitcoin-Transaktion",
    "cjzh": "Konto erstellen",
  },
  "xbsg":{
    "title": "Neue Münzzone",
    "wdsg": "Einzelheiten",
    "scts": "Sperrtage: ",
    "sy": "verbleibend",
    "ljsg": "Abonniere jetzt",
    "ysk": "Ausverkauft",
    "xzjdy": "Abonniere jetzt",
    "dy": "Abonnieren",
    "fxjg": "Ausgabepreis",
    "fxl": "Verkehr",
    "ssrq": "Angebotsdatum",
    "yxqx": "Gültigkeitszeitraum",
    "qsrsl": "Bitte Betrag eingeben",
    "syl": "verbleibend",
    "sgrq": "Abonnieren",
    "sgsl": "Höhe",
    "bz": "Münze",
    "yebz": "Unzureichendes USDT-Guthaben",
    "tgsl": "Passmenge",
    "shz": "unter Überprüfung",
    "wtg": "Nicht bestanden",
    "ytg": "bestanden"
  },
  "wydb":{
    "title": "Ausleihen",
    "db": "Ausleihen",
    "dbz": "Ausleihen",
    "jl": "Ausleihunterlagen",
    "jdzq": "Zeitraum (Tage)",
    "qhk": "Zurückzahlen",
    "ljdb": "Kumulativ (usd)",
    "dhkbs" :"Rückzahlung",
    "jkje": "Kreditbetrag (usdt)",
    "qsrje": "Bitte Betrag eingeben",
    "rll": "Tageszinssatz",
    "hkfs": "Rückzahlung",
    "dqych": "Abgelaufen",
    "lx": "Interesse",
    "fkjg": "Darlehensgeber",
    "tpsc": "Kreditdarlehen (Bild-Upload)",
    "fwxx": "Wohninformationen",
    "srzm": "Einkommensnachweis (Arbeitsverhältnis)",
    "yhmx": "Kontoauszug",
    "zjz": "Ausweisfoto",
    "yd": "Ich habe gelesen und zugestimmt",
    "xy": "Beantragen Sie einen Kreditvertrag",
    "sqdb": "Beantragen Sie einen Kredit",
    "gb": "Schließung",
    "qd": "OK",
    "ts": "Bitte überprüfen Sie Kreditvertrag beantragen",
    "dbjl": "aufzeichnen",
    "hkhth": "Bestellcode",
    "wsh": "Ungeprüft",
    "yfk": "Darlehen",
    "sqrq": "Bewerbungszeit",
    "zq": "Kreislauf",
    "dbsl": "Anzahl Rippen",
    "zhke": "Gesamtzahlung",
    "yhke":"Zurückgezahlter Betrag",
    "yhkxq": "Rückzahlungsdetails",
    "bqyhk": "Rückzahlbar in der aktuellen Periode(USDT)",
    "hktips": "Bitte stellen Sie sicher, dass das Guthaben ausreicht, wenn das Guthaben nicht ausreicht, laden Sie bitte zuerst auf und zahlen Sie dann zurück",
    "bj": "Rektor",
    "jie": "Ausleihen",
    "ljhk": "Sofort zurückzahlen",
    "qcz": "Deponieren",
    "yebzqxcz": "Unzureichendes Guthaben, bitte zuerst aufladen und dann zurückzahlen",
    "znj": "Gebühr für zu spätes Zahlen",
    "yqts": "Tage überfällig"
  },
  "hkxq":{
    "dd":"Befehl",
    "fzhkdz":"Kopieren Sie die Rückzahlungsadresse",
    "hkxq": "Rückzahlungsdetails",
    "zlx": "Gesamtinteresse",
    "zhk": "Gesamtrückzahlungen",
    "hkjg": "Rückzahlungsstelle",
    "qschkpz": "Bitte laden Sie die Rückzahlungsbescheinigung hoch",
    "hkpz": "Rückzahlungsbescheinigung"
  },
  "bbjyNew":{
    "jylx": "Arten von",
    "jyze": "Menge"
  },
  "bind":{
    "title": "Email",
    "ybd": "Gebunden",
    "wbd": "Ungebunden",
    "ts": "Um Ihr Konto zu schützen, wird empfohlen, eine E-Mail-Adresse zu binden",
    "qsryxdz": "Bitte E-Mail-Adresse eingeben"
  },
  "tipsNew": {
    "yjj": "abgelehnt",
    "shz": "Erlösung"
  },
  "newIndex2":{
    "zxhy": "Neueste Zitate",
    "jypt": "Handelsplattform",
    "ssyc": "Verbergen schrumpfen",
    "hwzc": "Noch nicht registriert?",
    "ljzc": "Melden Sie sich jetzt an und entdecken Sie unzählige Möglichkeiten!",
    "yyzh": "Haben Sie bereits ein Konto?",
    "hjbj": "Melde dich an, wenn du ein Konto hast, lange nicht gesehen!",
    "lmdh": "Spaltennavigation",
    "ghdjy": "Besseres Geschäft, besseres Leben",
    "ghdjy02": "Das weltweit innovativste Krypto-Handelszentrum ist hier, wo Sie Kryptowährungen mit Hunderten von Kryptowährungen kaufen, handeln und verdienen können.",
    "indexCont01": "Immer neben dir",
    "indexCont02": "Handeln Sie unsere Spot- und Margin-Märkte mit fortschrittlichen Finanzierungsoptionen, blitzschneller Ausführung und hoher Liquidität.",
    "indexCont03": "Leistungsstarke API",
    "indexCont04": "Verwalten Sie mühelos Ihre Positionen mit unserer intuitiven API, Handelsplattform und erweiterten Orderoptionen.",
    "indexCont05": "Hochwertige digitale Assets",
    "indexCont06": "9 Jahre 0 Unfälle",
    "indexCont07": "Top-Sicherheitsrisikokontrolle",
    "indexCont08": "Hebel bis zu 25 Mal",
    "indexCont09": "Handeln Sie Bitcoin-CFDs mit bis zu 25-facher Hebelwirkung.",
    "indexCont010": "Sicherheitsreserve",
    "indexCont011": "Tiefe Liquidität",
    "indexCont012": "Unsere fortschrittliche proprietäre Multi-Market-Orderbuch-Technologie verbessert die Liquidität, engt Spreads ein und reduziert Slippage.",
    "indexCont013": "Benutzereinstellung",
    "indexCont014": "Abgedecktes Land",
    "indexCont015": "Unsere Stärken",
    "indexCont016": "Handeln Sie unsere Spot- und Margin-Märkte mit fortschrittlichen Finanzierungsoptionen, blitzschneller Ausführung und hoher Liquidität.",
    "indexCont017": "Sicherer Speicher",
    "indexCont018": "Wir verwenden eine Kombination aus Cold Wallets und Multi-Party-Computing-Technologie (MPC), um digitale Assets zu verwalten.",
    "indexCont019": "Sicherheit geht vor",
    "indexCont020": "Wir verwenden die neueste Technologie, um Ihre Gelder zu schützen und Bugs und Exploit-Versuchen immer einen Schritt voraus zu sein.",
    "indexCont021": "Schnelle Auszahlung",
    "indexCont022": "Durch die Mehrparteienberechnung sind wir in der Lage, rund um die Uhr schnelle Abhebungen anzubieten und gleichzeitig unsere strengen Sicherheitsstandards einzuhalten.",
    "indexCont023": "Kryptowährung kaufen, verkaufen",
    "indexCont024": "Werden Sie Teil der umfassendsten und sichersten Handelsplattform der Welt",
    "indexCont025": "Kaufen und verkaufen Sie Bitcoin, Ethereum, XRP und viele andere Kryptowährungen mit Fiat- oder Kryptowährungen.",
    "yqwj": "10 Millionen+",
    "dlzc": "Melden Sie sich an, um sich zu registrieren",
    "yzm": "Bestätigungscode",
    "qrmm": "Passwort bestätigen"
  },
  "langNew2":{
    "flzq": "Belohnungszentrum",
    "qdjl": "Belohnung anmelden",
    "mrqdjl": "Tägliche Anmeldebelohnung",
    "qd": "anmelden",
    "yqd": "Angemeldet",
    "hdgz": "Veranstaltungsregeln",
    "qdjl2": "Check-in-Aufzeichnung",
    "qdcg": "Melden Sie sich erfolgreich an",
    "yhd": "Erworben",
    "lq": "Empfangen",
    "dyt": "Tag 1",
    "det": "Tag 2",
    "dst": "Tag 3",
    "dsit": "Tag 4",
    "dwt": "Tag 5",
    "dlt": "Tag 6",
    "dqt": "Tag 7",
    "jxz": "in Bearbeitung",
    "cjxnzh": "Virtuelles Konto erstellen",
    "sy":"Startseite",
    "sc":"Markt",
    "sclb":"Marktliste",
    "jy":"Handel",
    "zh":"Konto",
    "db":"Kredite",
    "zchm":"Registrierungsnummer",
    "cp":"Produkt",
    "tzjd":"Investitionskredite",
    "zxzc":"Online-Support",
    "xd":"Bestellung",
    "zzjptgmnr":"Investieren Sie in Ihre Zukunft. Erweitern Sie Ihr Portfolio in einem fairen und offenen Finanzsystem.",
    "yy":"App",
    "pqnr":"Mobiles Banking, das mit traditionellen Regeln bricht und Ihnen präzise Finanzmanagement-Tools bietet.",
    "jiami":"Krypto",
    "tgnr":"Durch Einzahlungen mit Kryptowährungen erhalten Sie eine zusätzliche Sicherheitsebene und können eine schnelle Transaktionsabwicklung gewährleisten.",
    "jyl":"24-Stunden-Handelsvolumen",
    "ssjmhb":"Krypto-Liste",
    "zchy":"Registrierte Benutzer",
    "djxz":"Klicken Sie hier, um herunterzuladen",
    "azsc":"Android Market",
    "pgsd":"Apple Store",
    "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
  },
  // "langNew":{
  //   "szhb": "Kryptowährung",
  //   "gjs": "Metall",
  //   "yy": "Roh",
  //   "jy": "Handeln",
  //   "jmhb": "Kryptowährung",
  //   "yxhy": "Unbefristeter Vertrag",
  //   "gdjy": "Ausstehende Bestellung",
  //   "khh": "Bankkonto",
  //   "qsrkhh": "Bitte geben Sie die Bank ein",
  //   "yhkh": "Bankkontonummer",
  //   "qsryhkh": "Bitte Bankkontonummer eingeben",
  //  },
   "login":{
     login: 'Bitte einloggen',
     msg: 'Bitte geben Sie Ihr registriertes Konto ein',
     list: ['Mobil/E-Mail','Passwort','Passwort vergessen?','Anmelden','Kein Konto, jetzt registrieren'],
     message: 'Konto oder Passwort dürfen nicht leer sein',
     "cdlks":"Beginnen wir mit der Anmeldung!",
     "zh":"Konto",
     "qsrzh":"Geben Sie Ihren Benutzernamen ein",
     "mm":"Passwort",
     "qsrmm":"Passwort eingeben",
     "dl":"Anmelden",
     "wjmm":"Passwort vergessen",
     "qbdl":"Melden Sie sich per Wallet an",
     "myzh":"Ich habe kein Konto?",
     "zc":"Melden Sie sich an",
     "yzm":"Bestätigungscode",
     "qsryzm":"Bestätigungscode eingeben",
     "hqyzm":"Code gesendet",
     "qrmm":"Bestätige das Passwort",
     "qsrqrmm":"Bestätige das Passwort",
     "lcmmbyz":"Die beiden Passworteingaben sind inkonsistent",
     "mmts":"Passwortlänge 6-12 Zeichen",
     "sjtx":"Fehler im Format der Telefonnummer",
     "yxts":"Fehler im E-Mail-Format",
     "qr":"OK",
     "sjzc":"Handy, Mobiltelefon",
     "sjh":"Telefonnummer",
     "qsrsjh":"Telefonnummer eingeben",
     "yqm":"Einladungscode (optional)",
     "qsryqm":"Geben Sie den Einladungscode ein",
     "yxzc":"Email",
     "wyydbzx":"Zustimmen",
     "yhxy":"<Benutzerdienstvereinbarung>",
     "yhxy2":"Benutzerdienstvereinbarung",
     "ysyx":"<Datenschutzvereinbarung>",
     "yx":"Email",
     "qsryx":"Email eingeben",
     "yxgsbzc":"Ungültige E-Mail",
     "cjmnzhcg":"Demokonto erfolgreich erstellt",
     "tcmnzh":"Demokonto verlassen",
     "qbdlts":"Bitte verwenden Sie die DAPP-Wallet-Anmeldung",
   },
  //  "index":{
  //    "xgnysx":"Neue Funktionen sind online!",
  //    "hyld":"Willkommen auf unserer preisgekrönten Finanzhandelsplattform und erkunden Sie die Finanzwelt der Zukunft mit globalen Investoren",
  //    "symncz":"Verwenden Sie ein Demokonto",
  //    "zdjyfy":"Mindesttransaktionsgebühren <0,3 %",
  //    "jysyzc":"Handeln Sie alle Ihre Vermögenswerte an einem Ort",
  //    "hbsp":"Forex, Kryptowährungen, Aktien, Indizes, Rohstoffe",
  //    "ksjy":"Start",
  //    "jdewd":"Einfach und stabil",
  //    "aizb":"Goldener KI-Handel",
  //    "srjh":"Erstellen Sie Ihren Einkommensplan mit einem Klick",
  //    "kssy":"Beginnen Sie mit der Verwendung",
  //    "dlyhggdje":"Niedrige Zinsen und höhere Beträge",
  //    "jmhbdk":"Kryptowährungskredite",
  //    "zmyrhdyp":"Leihen Sie sich Kryptowährungen ohne Sicherheit aus",
  //    "gs":"Unternehmen",
  //    "gywm":"Über uns",
  //    "xkzjd":"Lizenzüberwachung",
  //    "bzzx":"Hilfezentrum",
  //    "zhengce":"Politik",
  //    "tkytj":"Geschäftsbedingungen",
  //    "yszc":"Datenschutzrichtlinie",
  //    "sm":"Stellungnahme",
  //    "flxx":"Rechtsinformation",
  //    "mzsm":"Haftungsausschluss",
  //    "fxjg":"Risikowarnung",
  //    "gygg":"Über Werbung",
  //    "gg":"Bekanntmachung",
  //  },
   "hq":{
     "wh":"Forex",
     "szhb":"Krypto",
     "gp":"Aktie",
     "zs":"Index",
     "eft":"ETF",
     "mc":"Name",
     "xs":"24h%",
     "tb":"Diagramm",
     "jg":"Preis",
   },
   "user":{
     "wdzh":"Mein Konto",
     "zh":"Konto: ",
     "dk":"Darlehen: ",
     "sydbzj":"Verwendete Marge: ",
     "yqll":"Erwarteter Gewinn: ",
     "qtgn":"Andere Funktionen",
     "cz":"Kaution",
     "tx":"Zurückziehen",
     "dh":"Austausch",
     "zhyz":"KYC-Zertifizierung",
     "zhjl":"Kontoverlauf",
     "yqhy":"Freunde einladen",
     "flzq":"Wohlfahrtszone",
     "ggmm":"Kennwort ändern",
     "sz":"Einstellungen",
     "cjwtjd":"FAQ",
     "fzdz":"Adresse kopieren",
     "sl":"Menge...",
     "qsrsl":"Geben Sie die Menge ein",
     "dd":"Holen Sie sich (USDT): ",
     "sczm":"Gutschein hochladen",
     "qsczm":"Bitte Gutschein hochladen",
     "tj":"Einreichen",
     "czjl":"Einzahlungsprotokoll",
     "ddh":"NEIN.",
     "wsh":"Nicht überprüft",
     "ywc":"Vollendet",
     "bz":"Name: ",
     "sl2":"Menge: ",
     "sj":"Zeit: ",
     "srsl":"Menge eingeben...",
     "dd2":"Erhalten: ",
     "qskgzflhd":"Bitte achten Sie immer auf Wohlfahrtsaktivitäten, wir werden diese von Zeit zu Zeit freigeben",
     "hdlb":"Veranstaltungsliste",
     "ckxq":"Details anzeigen",
     "wdjl":"Meine Belohnung",
     "yiji":"Level 1",
     "erji":"Level 2",
     "sanji":"Stufe 3",
     "je":"Menge",
     "sj2":"Zeit",
     "yyxz":"Sprache",
     "tcdl":"Abmelden",
     "je2":"Betrag (USD)...",
     "qsrje":"Geben Sie den Betrag ein",
     "jsdz":"Empfangsadresse...",
     "qsrjsdz":"Geben Sie die Empfangsadresse ein",
     "sjdz":"Tatsächliche Ankunftszeit: ",
     "sxf":"Gebühr: ",
     "txsm1":"Für Abhebungen fällt eine Gebühr von 5 % an, die vom Netzwerkknoten bestätigt werden muss, bevor sie gutgeschrieben werden kann",
     "txsm2":"Bitte überweisen Sie keine Kryptowährungen an Fremde",
     "tz":"Benachrichtigen",
     "wdyq":"Meine Einladung",
     "yhid":"UID",
     "hdjl":"Erhalten Sie USD-Prämien",
     "yqsm":"Laden Sie Ihre Freunde ein, an der KI-Quantifizierung teilzunehmen, Mining-Maschinen zu mieten und Produkte zu handeln, um Kryptowährungsprämien zu erhalten",
     "yqsy":"Einladungseinnahmen",
     "yqrs":"Anzahl der eingeladenen Personen",
     "tgljyq":"Per Link einladen",
     "lj":"Verknüpfung",
     "yqm":"Einladungscode",
     "cbtb":"Einzahlen und abheben",
     "jymx":"Transaktionsdetails",
     "yqhyjl":"Belohnungen für das Einladen von Freunden",
     "aidd":"Goldene AI-Handelsaufträge",
     "jdls":"Kredithistorie",
     "etfdd":"ETF-Bestellungen",
     "jmhbdd":"Bestellungen in Kryptowährungen",
     "whdd":"Forex-Bestellungen",
     "gpdd":"Lagerbestellungen",
     "qx":"Stornieren",
     "zc":"Vermögenswerte",
     "zzc":"Gesamtvermögen",
     "ky":"Verfügbar",
     "zh2":"Umgerechnet (USDT)",
     "xzbz":"Wählen: ",
     "sztkts":"Wichtig: Bitte gehen Sie zum Sicherheitscenter, um ein Transaktionspasswort festzulegen",
     "jymm":"Transaktions Passwort",
     "szjymm":"Transaktionspasswort festlegen",
     "qsrjymm":"Transaktions Passwort",
     "zdsl":"Mindestmenge.",
     "bq":"Schlagwort(Memo)",
     "qsrbq":"Tag eingeben",
     "yhktx":"Banküberweisung",
     "yhmc":"Bank Name",
     "qsryhmc":"Geben Sie den Banknamen ein",
     "yhzh":"Bankkonto",
     "qsryhzh":"Geben Sie die Bankkontonummer ein",
     "gjhkdm":"SWIFT-Code",
     "qsrgjhkdm":"Geben Sie den SWIFT-Code ein",
     "yhdz":"Bankadresse",
     "qsryhdz":"Geben Sie die Bankadresse ein",
     "skrxm":"Name des Zahlungsempfängers",
     "qsrskrxm":"Geben Sie den Namen des Zahlungsempfängers ein",
     "skrdh":"Telefonnummer des Zahlungsempfängers",
     "qsrskrdh":"Geben Sie die Telefonnummer des Zahlungsempfängers ein",
     "skrdz":"Adresse des Zahlungsempfängers",
     "qsrskrdz":"Geben Sie die Adresse des Zahlungsempfängers ein",
     "tbjl":"Auszahlungsprotokoll",
     "fzcg":"Erfolgreich kopiert",
     "aqzx":"Sicherheitscenter",
     "yxrz":"E-Mail-Authentifikation",
     "ybd":"Gebunden",
     "wbd":"Nicht gebunden",
     "yrz":"Verifiziert",
     "wrz":"Nicht zertifiziert",
     "ts":"Um Ihr Konto zu schützen, wird empfohlen, Ihre E-Mail-Adresse zu verknüpfen",
     "qsryxdz":"Email eingeben",
     "dlmm":"Passwort",
     "mbwtsz":"Einstellungen für Sicherheitsprobleme",
     "mbwt":"Sicherheitsproblem",
     "qtxda":"Bitte füllen Sie die Antwort aus",
     "zyts":"Wichtig: ",
     "zytsCont":"Bitte geben Sie die Sicherheitsantwort und den Bestätigungscode nicht weiter und denken Sie an die Sicherheitsfrage, die Ihnen bei der Wiederherstellung Ihres Passworts hilft.",
     "qsrxmm":"Geben Sie ein neues Kennwort ein",
     "sydqmmcz":"Mit aktuellem Passwort zurücksetzen",
     "zhmm":"Sicherheitsproblem beim Abrufen des Passworts",
     "ysz":"Wurde festgelegt",
     "tg":"ignorieren",
     "qsrdlmm":"Geben Sie Ihr Passwort ein",
     "bzxz":"Wählen: ",
     "zwsj":"Keine Daten",
     "qd":"OK",
     "zsgd":"Zeig mehr",
     "zdss":"Mindestlosgröße",
     "mnjy":"Simulierter Handel",
     "sx":"Bildschirm",
   },
   "zb":{
     "tgdd":"KI verwaltete Bestellungen",
     "tgz":"In Gewahrsam",
     "ysh":"Eingelöst",
     "shz":"Abgesagt",
     "zq":"Zyklus: ",
     "tian":"Tag",
     "syl2":"Rendite: ",
     "rgjg":"Einschreibegebühr: ",
     "rgjg2":"Einschreibegebühr",
     "xdsj":"Bestellzeitpunkt: ",
     "yhl":"Profitiert: ",
     "syts":"Die verbleibende Anzahl an Tagen: ",
     "sh":"Rückzahlung",
     "syl":"Rendite",
     "bz":"Name",
     "dl":"Tauschrate",
     "tgts":"Hosting-Tage: ",
     "tgsl":"Hosting-Menge",
     "qsrtgsl":"Geben Sie die Hosting-Menge ein",
     "dbxe":"Einzeltransaktionslimit",
     "ljtg":"Jetzt Gastgeber sein",
     "zztg":"Gelder in Verwahrung",
     "yjjrsy":"Geschätzter Verdienst heute",
     "ljsy":"Kumuliertes Einkommen",
     "tgzdd":"Anordnung in Untersuchungshaft",
     "ljzc":"Jetzt übertragen",
     "gz":"Regel",
     "cpzq":"Produktzyklus",
     "gm":"Kaufen",
     "ts":"Wichtig",
     "shts":"Sie befinden sich im Rücknahmevorgang und verlieren 5 %, wenn Sie die Rückzahlung vor Fälligkeit vornehmen. Sind Sie sicher, dass Sie es einlösen möchten?",
     "xgcs":"Anzahl der Kaufbeschränkungen",
   },
   "dk":{
     "dk":"Darlehen",
     "dkzh":"Darlehenskonto",
     "yzsf":"Verifizieren Sie Ihre Identität und erhalten Sie mehr Kreditbeträge!",
     "ksyz":"Bestätigung starten",
     "wxj":"Ich möchte mir etwas ausleihen...",
     "dkqx":"Kreditlaufzeit (Tage): ",
     "mrll":"Tageszinssatz: ",
     "lxze":"Gesamtzins: ",
     "dkts":"Für das Darlehen fallen für 3 Tage keine Zinsen an, danach können die Zinsen gezahlt werden",
     "xzj":"Jetzt leihen",
     "wyydbzx":"Zustimmen",
     "dkfwxy":"<Darlehensdienstleistungsvertrag>",
     "dkfwxy2":"Kreditdienstvereinbarung",
     "dkysxy":"Kredit-Datenschutzvereinbarung",
     "dkjl":"Kredithistorie",
     "hth":"NEIN.",
     "yfk":"Ausgezahlt",
     "lx":"Interesse: ",
     "zhke":"Gesamtrückzahlungsbetrag: ",
     "znj":"Gebühr für zu spätes Zahlen: ",
     "znjl":"Verspätungsgebührensatz: ",
     "yqts":"Tage überfällig: ",
     "qhk":"Zurückzahlen",
     "tpsc":"Kreditdarlehen (Bild-Upload)",
     "fwxx":"Wohninformationen",
     "srzm":"Einkommensnachweis (Arbeitsverhältnis)",
     "yhmx":"Bankdaten",
     "zjz":"Ausweisfoto",
     "ljdk":"Jetzt leihen",
     "xm":"Name",
     "ndxm":"Ihr Name",
     "qsrndxm":"Gib deinen Namen ein",
     "gj":"Land",
     "ndgj":"Dein Land",
     "qsrndgj":"Geben Sie Ihr Land ein",
     "dz":"Adresse",
     "nddz":"Deine Adresse",
     "qsrnddz":"Geben Sie Ihre Adresse ein",
     "csrq":"Geburtsdatum",
     "ndcsrq":"Dein Geburtsdatum",
     "qsrndcsrq":"Gib dein Geburtsdatum ein",
     "dhhm":"Telefonnummer",
     "nddhhm":"Deine Telefonnummer",
     "qsrnddhhm":"Gib deine Telefonnummer ein",
     "zj":"Unterlagen",
     "sfzm":"Positive Identität",
     "qscsfzm":"Laden Sie die positive Seite Ihrer Identität hoch",
     "sffm":"Gegenteil von Identität",
     "qscsffm":"Laden Sie die Rückseite Ihrer Identität hoch",
     "ddqr":"Bestellbestätigung",
     "jk":"Darlehen: ",
     "dkqx2":"Kreditlaufzeit: ",
     "qrxd":"Bestellung bestätigen",
     "yhkxq":"Einzelheiten zur fälligen Rückzahlung",
     "hkqr":"Rückzahlungsbestätigung",
     "yhk":"Fällige Rückzahlung: ",
     "jksj":"Ausleihzeit: ",
     "ljhk":"Sofort auszahlen",
   },
   "jy":{
     "rq":"Datum",
     "qqjy":"Optionsdatensatz",
     "hyjy":"Vertrag",
     "qqhy":"Optionen",
     "dqwt":"Ausstehend",
     'wtz':"Im Auftrag",
     "hyjl":"Vertragsprotokoll",
     "shou":"Viele",
     "dk":"Ö: ",
     "zhjg":"Neueste: ",
     "jyfy":"Transaktionsgebühr: ",
     "kfsj":"Öffnungszeiten: ",
     "gg":"Hebel: ",
     "pl":"Charge: ",
     "kpj":"Eröffnungskurs: ",
     "yk":"Gewinn-und Verlust: ",
     "cd":"Bestellung stornieren",
     "jsj":"Abrechnungspreis: ",
     "fx":"Richtung: ",
     "jgsj":"Lieferzeit: ",
     "gb":"Schließen",
     "jxxd":"Weitermachen",
     "xj":"Grenze: ",
     "gm":"Kaufen: ",
     "sl":"Menge",
     "fy":"Kosten: ",
     "tzbzj":"Rand anpassen",
     "zyzs":"Gewinn mitnehmen und Verlust stoppen",
     "pc":"Geschlossene Position",
     "mr":"Kaufen",
     "zjbzj":"Marge erhöhen",
     "jsbzj":"Marge reduzieren",
     "yxhy":"Vertragshandel: ",
     "cc":"Position(en): ",
     "cc2":"Position",
     "cwbzk":"Positionsrand: ",
     "zdzjbzj":"Maximale Margenerhöhung: ",
     "zjbzj2":"Marge erhöhen: ",
     "qsrzbzj":"Bitte geben Sie die Anzahlung ein",
     "yxhy2":"Ewig",
     "kp":"Kann flach sein",
     "zhang":"Offen",
     "xj2":"Grenze",
     "zy":"Nehmen Sie Gewinn mit",
     "zs":"Stop-Loss",
     "ssjyzl":"Transaktionstyp suchen",
     "ddb":"Auftragsbuch",
     "di":"L: ",
     "gao":"H: ",
     "gb2":"C: ",
     "fz":"Minute",
     "mai":"Kaufen: ",
     "zhang2":"Erheben",
     "tie":"Fallen",
     "sy":"Zurückkehren",
     "kz":"Bullisch",
     "kt":"Bärisch",
     "bndy":"Darf nicht niedriger sein als",
     "sxbzj":"Erforderliche Kaution: ",
     "ky":"Verfügbar: ",
     "sj":"Markt",
     "mc":"Verkaufen",
     "zxtzsl":"Mindestens hinzufügen",
     "min":"Mindestbetrag",
     "max":"Größter Betrag",
     "yebz":"Mangelhaftes Gleichgewicht",
     "ddz":"Warten",
     "wtzl":"Höhe der Provisionen: ",
     "wtjg":"Provisionspreis: ",
     "ycd":"Abgesagt",
     "lswt":"Historisch",
     "qsrzyjg":"Bitte geben Sie den Take-Profit-Preis ein",
     "qsrzsjg":"Bitte geben Sie den Stop-Loss-Preis ein",
     "ccsl":"Anzahl der Positionen: ",
     "ccjg":"Positionspreis: ",
     "ggbs":"Nutzen Sie mehrere: ",
     "zy2":"Gewinn mitnehmen: ",
     "zs2":"Stop-Loss: ",
     "zje":"Pauschalbetrag: ",
     "ss":"Viele: ",
     "kcjg":"Eröffnungskurs: ",
     "bzjl":"Margin-Rate: ",
     "lscc":"Historische Positionen",
     "gmj":"Kaufpreis: ",
     "guadan":"Ausstehende Bestellung",
     "dqjg":"Derzeitiger Preis: ",
     "gdjg":"Ausstehender Bestellpreis: ",
     "pcjg":"Schlusskurs: ",
     "ccsj":"Positionshaltezeit: ",
     "gdsj":"Dauer der ausstehenden Bestellung: ",
     "pcsj":"Geschäftsschluss: ",
     "fdjyk":"Variabler Nettogewinn und -verlust",
     "pcsl":"Schlussmenge",
     "qrpc":"Bestätigen Sie das Schließen der Position",
     "ypc":"Position geschlossen",
     "ss2":"Viele",
     "qsrss":"Geben Sie die Losgröße ein",
   },
   "gjrz":{
     "sfyz":"KYC-Zertifizierung",
     "t1":"1. Unterstützt Bilder im JPG-, JPEG- oder PNG-Format, die kleiner als 8 MB sind.",
     "t2":"2. Das Ausweisfoto muss klar sein und darf nicht verändert oder blockiert werden. Das Porträt, die Ausweisnummer und der Name müssen deutlich sichtbar sein.",
     "t3":"3. Das Foto muss ohne Hut aufgenommen werden und es wird empfohlen, kein Make-up zu tragen. Die Gesichtszüge der Person, die das Dokument hält, müssen deutlich sichtbar sein und der gesamte Arm muss freigelegt sein.",
     "t4":"OK",
     "bh":"Ablehnen",
     "shz":"Wird überprüft",
     "shtg":"Prüfung bestanden",
     "nyrzcg":"Sie wurden erfolgreich authentifiziert",
     "sczjz":"Ausweisfoto hochladen",
     "sczjzmz":"Laden Sie ein Foto Ihres Ausweises mit der Vorderseite hoch",
     "sczjbmz":"Laden Sie das Foto der Rückseite Ihres Ausweises hoch",
     "scgrqmz":"Laden Sie ein Foto Ihres Personalausweises in der Hand hoch",
     "gjlb":"Länderliste",
     "qxzgjlb":"Wählen Sie ein Land/eine Region aus",
     "zsxm":"Tatsächlicher Name",
     "qsrzsxm":"Geben Sie Ihren richtigen Namen ein",
     "zjlx":"Art des Zertifikats: ",
     "zjhm":"ID-Nummer",
     "qsrzjhm":"Geben Sie Ihre ID-Nummer ein",
     "khh":"Kontoeröffnungsbank",
     "qsrkhh":"Geben Sie die Kontoeröffnungsbank ein",
     "yhkh":"Bankkartennummer",
     "qsryhkh":"Geben Sie die Bankkartennummer ein",
   },
   "status":{
     "statusText":['Fehlgeschlagen','Wird überprüft','Erfolgreich'],
   },
   "download":{
     "t1":"Mobiler Handel, jederzeit und überall",
     "xz":"Herunterladen",
   },
   "langNew":{
     "jmm": "Altes Passwort",
     "qsrjmm": "Bitte geben Sie Ihr altes Passwort ein",
     "szhb": "Kryptowährung",
     "gjs": "Metall",
     "ny": "Energie",
     "yy": "Roh",
     "jy": "Handeln",
     "jmhb": "Kryptowährung",
     "yxhy": "Unbefristeter Vertrag",
     "gdjy": "Ausstehende Bestellung",
     "khh": "Bankkonto",
     "qsrkhh": "Bitte geben Sie die Bank ein",
     "yhkh": "Bankkontonummer",
     "qsryhkh": "Bitte Bankkontonummer eingeben",
     "mnzh":"Demokonto",
     "zjjypt":"Beste Handelsplattform",
     "brjmzndxq":"Diese Software erfüllt alle Ihre Anforderungen mit dem besten technischen Know-how",
     "jx":"Weitermachen",
     "yssm":"Datenschutzerklärung",
     "fxqzc":"Richtlinie zur Bekämpfung der Geldwäsche",
     "jgxkz":"Behördliche Lizenz",
     "ckgd":"Mehr",
     "gd":"Mehr",
     "dd":"Befehl",
     "ckdd":"Bestellungen anzeigen",
     "yxdd":"Ewig",
     "qqdd":"Optionen",
     "hand":"l viele= ",
     "lxwm":"Kontaktiere uns",
     "tpfzl":"Platzieren Sie Ihr Bild hier oder stöbern Sie",
     "liulang":"stöbern Sie",
     "zctpgs":"Unterstützung: JPG, JPEG2000, PNG",
     "ysr":"Monatliches Einkommen",
     "ndysr":"Ihr monatliches Einkommen",
     "qsrndysr":"Geben Sie Ihr monatliches Einkommen ein",
     "yqtzje":"Erwarteter Investitionsbetrag",
     "qsrtzje":"Geben Sie den erwarteten Investitionsbetrag ein",
     "zszh":"Echter Account",
     "qdl":"Bitte einloggen",
     "zx":"Favoriten",
     "hkdz":"Rückzahlungsadresse",
     "dkje":"Kreditbetrag: ",
     "zlx":"Gesamtzins: ",
     "hkze":"Gesamtrückzahlung: ",
     "qcz":"Zur Einzahlung",
     "yebz":"Ihr Guthaben reicht nicht aus, bitte aufladen",
     "dhje":"Zurückzuzahlender Betrag：",
     "hkjl":"Rückzahlungsauftrag：",
     "hkje":"Rückzahlung：",
     "kyye":"Saldo：",
     "qb": 'Alle',
     "lmc": "Kettenname：",
     "search": "Suchen",
     "mrjg":"Preis",
     "lxkf":"Kontakt",
     "wyj":"Vertragsstrafe",
     "yxsj":"Läuft：",
     "jssj":"Beenden：",
     "hksj":"Rückzahlung：",
     "sysj":"Übrige Zeit：",
     "jkqx":"Kreditlaufzeit：",
     "yq":"Überfällig：",
     "qqss":"Ihr Optionshandelsauftrag ist abgelaufen und Ihr Verlust ist abgelaufen",
     "qqlr":"Ihr Optionshandelsauftrag ist abgelaufen und Ihr Gewinn ist abgelaufen",
     "bz":"Währung",
     "dzje":"Erhaltener Betrag",
     "lxyxzc":"E-Mail-Support",
   },
   "langNew9":{
   "dzje":"Markttrends bei Handelsprodukten",
   "lxyxzc":"Beginnen Sie Ihre digitale Handelsreise",
   "text1":"Erstellen Sie zunächst ein Konto",
   "text2":"Laden Sie Freunde ein, MFTG beizutreten und gemeinsam zu spielen",
   "text3":"Laden Sie Ihr Konto auf",
   "text4":"Unterstützen Sie das Aufladen mehrerer Währungen, damit Sie schnell mit dem Handel beginnen können",
   "text5":"Beginnen Sie mit dem Handel",
   "text6":"Bieten Sie eine Vielzahl hochwertiger Handelspaare zur Auswahl und handeln Sie mit Freude bei MFTG",
    "text7":"Laden Sie Freunde ein, um USDT zu verdienen",
    "text8":"Laden Sie Freunde ein, um ganz einfach USDT zu verdienen",
    "text9":"Die Kreditfunktion ist online",
    "text10":"Wenn Sie kein Geld haben, können Sie einen Kredit beantragen, der frühestens am selben Tag ausgezahlt wird",
    "text11":"Handel mit allen Vermögenswerten",
    "text12":"Forex, Kryptowährungen, Futures, ETFs usw.",
   },
   "bank":{
     "text1":"Ihre vertrauenswürdigste Finanzmanagementplattform",
     "text2":"Nachrichtenbenachrichtigungen in Echtzeit",
     "text3":"Verstehen Sie Echtzeitinformationen über die Finanzbranche",
     "text4":"fange an zu verstehen",
     "text5":"Nachrichtenblitz",
     "text6":"Wählen Sie eine Bank",
     "text7":"Bankkarte",
     "text8":"Menge...",
     "text9":"Bankkarte hinzufügen",
     "text10":"Bankkonto",
     "text11":"Bitte geben Sie das Bankkonto ein",
     "text12":"Karten-ID",
     "text13":"Bitte geben Sie die Kartennummer ID ein",
     "text14":"Internationale Bankleitzahl",
     "text15":"Internationale Bankleitzahl",
     "text16":"Bitte geben Sie die Telefonnummer ein",
     "text17":"Hinzufügen zu",
     "text18":"Bankkarte löschen",
     "text19":"Tatsächlicher Eingang",
     "text20":"Auszahlungsinformationen",
     "text21":"Bankkarte auswählen",
     "text22":"Hinweise",
     "text23":"Mindestauszahlungsbetrag:",
     "text24":"Auszahlungen sind nicht zulässig, wenn der Betrag unter dem Mindestauszahlungsbetrag liegt",
     "text25":"• Um die Sicherheit der Gelder zu gewährleisten, überprüfen wir die Auszahlung manuell, wenn sich die Sicherheitsrichtlinie Ihres Kontos oder Ihr Passwort ändert. Bitte warten Sie geduldig, bis das Personal Sie per Telefon oder E-Mail kontaktiert.",
     "text26":"• Bitte stellen Sie sicher, dass Ihr Computer und Browser sicher sind, um zu verhindern, dass Informationen manipuliert oder weitergegeben werden.",
     "text27":"• Für die von Ihnen abgehobenen USD bedeutet jede Operation, dass der Gesamtbetrag der auf der Auszahlungsseite angezeigten Vermögenswerte, die Sie besitzen, um den entsprechenden Auszahlungsbetrag reduziert wird.",
     "text28":"Auszahlungsaufzeichnung",
     "text29":"Fiat-Währungstyp",
   },
   "team":{
     "tdjs":"Teamvorstellung",
     "wmdtd":"Unser Team",
     "tdjj":"Wir bieten Händlern niedrigere Transaktionskosten, eine bessere Auftragsausführung und sicherere Finanzdienstleistungen. Treten Sie einem erstklassigen Handelsmakler bei, der Ihnen die einfache Teilnahme am globalen Finanzmarkt ermöglicht.",
     "gltdjs":"Vorstellung des Managementteams",
     "mc0":"Christian James Oram",
     "mc1":"Ari Cohen",
     "mc2":"David Charles Harrison",
     "mc3":"David Harding",
     "mc4":"Markus Johann Fischer",
     "mc5":"Michael Levine",
     "mc6":"Robin Matthes",
     "mc7":"Satya Raito",
     "zc0":"Vorstandsvorsitzender(CEO)",
     "zc1":"Chief Technology Officer",
     "zc2":"Finanzvorstand(CFO)",
     "zc3":"Rechtsberater",
     "zc4":"Chief Operating Officer(COO)",
     "zc5":"Chief Investment Officer(CIO)",
     "zc6":"Chief Credit Officer",
     "zc7":"Direktor für Daten und künstliche Intelligenz",
     "text01":"Sicherheit und Transparenz",
     "text02":"Wir achten stets auf die Sicherheit der Benutzerressourcen",
     "text03":"Multinationale Regulierungslizenz",
     "text04":"Vermögensschutzvereinbarung",
     "text05":"Unabhängige Prüfung durch drei Parteien",
     "text06":"Beste Handelsbedingungen",
     "text07":"Ultimatives Handelserlebnis",
     "text08":"Unterstützung mehrerer Handelstools",
     "text09":"Effiziente Auftragsabwicklung",
     "text10":"Professionelle K-Line-Daten",
     "text11":"Sind Sie bereit, Ihre Karriere bei uns zu starten?",
     "ljks":"Beginnen Sie jetzt",
     "技术副总裁":"Vizepräsident für Technologie",
     "公共关系与对外事务总监":"Direktor für öffentliche Angelegenheiten und externe Beziehungen",
     "首席战略官":"Chief Strategy Officer",
     "首席人工智能科学家":"Leitender KI-Wissenschaftler",
     "首席风险官":"Risikovorstand"
   },
   "aiDetail":{
     "syxq":"Einzelheiten zu den Einnahmen",
     "zsy":"Gesamtumsatz",
     "rq":"Datum",
   },
   kdkje: 'Verfügbarer Kreditbetrag'
   // "langNew2":{
   //   "sy":"Startseite",
   //   "sc":"Markt",
   //   "sclb":"Marktliste",
   //   "jy":"Handel",
   //   "zh":"Konto",
   //   "db":"Kredite",
   //   "zchm":"Registrierungsnummer",
   //   "cp":"Produkt",
   //   "tzjd":"Investitionskredite",
   //   "zxzc":"Online-Support",
   //   "xd":"Bestellung",
   //   "zzjptgmnr":"Investieren Sie in Ihre Zukunft. Erweitern Sie Ihr Portfolio in einem fairen und offenen Finanzsystem.",
   //   "yy":"App",
   //   "pqnr":"Mobiles Banking, das mit traditionellen Regeln bricht und Ihnen präzise Finanzmanagement-Tools bietet.",
   //   "jiami":"Krypto",
   //   "tgnr":"Durch Einzahlungen mit Kryptowährungen erhalten Sie eine zusätzliche Sicherheitsebene und können eine schnelle Transaktionsabwicklung gewährleisten.",
   //   "jyl":"24-Stunden-Handelsvolumen",
   //   "ssjmhb":"Krypto-Liste",
   //   "zchy":"Registrierte Benutzer",
   //   "djxz":"Klicken Sie hier, um herunterzuladen",
   //   "azsc":"Android Market",
   //   "pgsd":"Apple Store",
   //   "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
   // }
}



// WEBPACK FOOTER //
// ./src/lang/de.js